class MoonPhasePicker extends HTMLElement {
  constructor() {
    super();

    this.selectedImage = this.querySelector('.selected-image');
    this.imageModal = this.querySelector('.image-modal');
    this.closeButton = this.querySelector('.close');
    this.datePicker = this.closest('moon-phase-finder').querySelector('.date-picker');
    this.currentFinder = this.closest('moon-phase-finder');
    this.index = this.currentFinder.dataset.index;
    this.input = document.querySelector(`#select-moon-phase-data-${this.index}`);
    this.moonPhaseElement = this.currentFinder.querySelector('.moon-phase-name');

    DatePickerModal.initFlatpickr(this.datePicker, this.datePicker.dataset.instance);
    this.handleEvents();
  }

  handleEvents() {
    this.selectedImage.click();
    this.selectedImage.addEventListener('click', this.openModal.bind(this));
    this.closeButton.addEventListener('click', this.closeModal.bind(this));
    this.imageModal.addEventListener('click', this.updateMoonColor.bind(this));
    this.moonPhaseElement.addEventListener('click', this.querySelector('.selected-image').click.bind(this.selectedImage));

    const dateSelectedEvent = `dateSelected-${this.datePicker.dataset.instance}`;

    document.addEventListener(dateSelectedEvent, async (e) => {
      const date = e.detail.date; // "20-1-2025"
      this.day = Number(date.split('-')[0]);
      this.month = Number(date.split('-')[1]);
      this.year = Number(date.split('-')[2]);
      const moonPhase = await MoonCalculator.fetchCalendarData(date);
      const moonPhaseName = MoonCalculator.getMoonPhaseName(moonPhase);
      const color = this.selectedImage.querySelector('img').dataset.color;
      this.updateImages(moonPhase);
      this.updateMoonPhaseName(moonPhaseName, this.currentFinder);
      this.updateInputValue(moonPhaseName, color);
      this.datePicker.classList.add('filled');
      this.dispatchUpdate();
    });
  }

  dispatchUpdate() {
    const event = new CustomEvent('calendar:updated', {
      detail: {
        element: this.input.value,
        index: this.index
      }
    });
    document.dispatchEvent(event);
  }

  updateInputValue(moonPhaseName, color) {
    color = color ? color : 'Natural';
    const monthName = MoonCalculator.getMonthName(this.month);
    this.input.value = `${moonPhaseName} / ${this.day} ${monthName} ${this.year} / ${color}`;
  }

  updateMoonPhaseName(name, currentFinder) {
    const moonPhaseName = this.moonPhaseElement.querySelector('.name');
    moonPhaseName.innerText = name;
    document.querySelector('.moon-phase-name').classList.remove('default');
  }

  closeImageModals() {
    const imageModals = document.querySelectorAll('.image-modal');
    imageModals.forEach(modal => {
      if (modal.classList.contains('active') && modal !== this.imageModal) {
        modal.classList.remove('active');
      }
    });
  }

  updateInputColor(color) {
    const value = this.input.value.split(' / ');
    value[2] = color;
    this.input.value = value.join(' / ');
  }

  updateMoonColor(event) {
    if (event.target.tagName === 'IMG') {
      const selectedImage = this.querySelector('.selected-image img'); // Dynamically fetch the updated element
      selectedImage.src = event.target.src; // Update the `src` dynamically
      selectedImage.dataset.color = event.target.dataset.color;
      selectedImage.classList.remove('default');
      this.updateInputColor(event.target.dataset.color);
      const colorElement = this.moonPhaseElement.querySelector('.color');
      colorElement.innerText = event.target.dataset.color;
      colorElement.dataset.color = event.target.dataset.color;
      document.querySelector('.moon-phase-name').classList.remove('default');
      this.closeModal();
      this.dispatchUpdate();
    }
  }

  updateImages(moonPhase) {
    const images = this.currentFinder.querySelectorAll('img');
    images.forEach((img, i) => {
      const updatedSrc = this.updateImgUrl(img, moonPhase);
      img.src = updatedSrc;
      if (i === 0) {
        img.classList.remove('default');
      }
    });
  }

  updateImgUrl(image, replacementCode) {
    const currentSrc = this.selectedImage.querySelector('img').src;
    const color = image.dataset.color;
    const parts = currentSrc.split('/');
    const lastPart = parts[parts.length - 1];
    const [prefix, suffix] = lastPart.split('_');
    const updatedPrefix = color === 'Blue' ? `P-${replacementCode}BL` : color === 'Green' ? `P-${replacementCode}GR` : `${replacementCode}`;
    const updatedFileName = `${updatedPrefix}_${suffix}`;
    parts[parts.length - 1] = updatedFileName;
    const updatedSrc = parts.join('/');
    return updatedSrc;
  }

  openModal() {
    this.closeImageModals();
    this.imageModal.classList.add('active');
  }

  closeModal() {
    this.imageModal.classList.remove('active');
  }
}

if (!customElements.get('moon-phase-picker')) customElements.define('moon-phase-picker', MoonPhasePicker);